import React from "react";
import Applet from "../../Applet";
import SupplierRevisionTable from "../../../../components/Supplier/SupplierRevisionTable";

class SupplierRevisionTableApplet extends Applet {

    render() {
        return <SupplierRevisionTable applet={this}
                                       pageSize={this.state.PageSize}
                                       placement={this.state.Placement}
                                       columns={this.state.Columns}
                                       title="Supplier"
                                       enterpriseComponent={this.getEnterpriseComponent()}
                                       sort={this.state.Sort}
                                       menu={this.state.Menu}
                                       rowHeight={this.state.RowHeight}
        />;
    }

    state = {
        Name: "SupplierRevisionTableApplet",
        Menu: {
            options: [
                {
                    displayValue: "New Supplier",
                    value: "New Supplier",
                },
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        RowHeight: 50,
        PageSize: {
            "default": 40,
            "xs": 3,
            "sm": 3,
            "md": 40,
            "lg": 40,
            "lx": 40,
        },
        Placement: {
            "xl": [
                {
                    id: "RecordPointer",
                },
                {
                    id: "DocumentID",
                },
                {
                    id: "DisplayStatus",
                },
                {
                    id: "Name",
                },
                {
                    id: "Actions",
                },
            ]
        },
        Columns: [
            {
                id: "RecordPointer",
                width: 25,
                cellRenderer: "Row Selection Indicator Cell",
                header: null,
                headerRenderer: "",
                headerTitle: "",
            },
            {
                id: "DocumentID",
                width: 325,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Document ID",
            },
            {
                id: "DisplayStatus",
                width: 125,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "State",
            },
            {
                id: "Name",
                width: 325,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Supplier Name",
            },
            {
                id: "Actions",
                width: 50,
                cellRenderer: "Action Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "",
                pinned: "right",
                hideable: false,
            }
        ],
        Sort: [
            {
                "Identifier": 1,
                "Visible": true,
                "Default": true,
                "Options": [{
                    "Direction": "DESC",
                    "SortAttribute": "DocumentID",
                    "DisplayName": "Document ID",
                }]
            },
            {
                "Identifier": 2,
                "Visible": true,
                "Default": true,
                "Options": [{
                    "Direction": "DESC",
                    "SortAttribute": "DocumentID",
                    "DisplayName": "Document ID",
                },
                {
                    "Direction": "DESC",
                    "SortAttribute": "DisplayStatus",
                    "DisplayName": "State",
                }]
            },
            {
                "Identifier": 3,
                "Visible": true,
                "Default": false,
                "Options": [{
                    "Direction": "ASC",
                    "SortAttribute": "Name",
                    "DisplayName": "Supplier Name",
                }]
            }
        ],
    };
}

export default SupplierRevisionTableApplet;
